export var ItemType;
(function (ItemType) {
    ItemType["Item"] = "item";
    ItemType["ItemScheduled"] = "item-scheduled";
    ItemType["ItemLive"] = "item-live";
    ItemType["ItemLiveFinalize"] = "item-live-finalize";
})(ItemType || (ItemType = {}));
//# sourceMappingURL=item-type.js.map